<template>
  <v-list class="mb-0">
    <v-list-item v-for="(item, i) in bullets" :key="i">
      <v-list-item-icon class="my-auto">
        <v-icon :color="color">{{ item.icon || icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-title
        class="py-2 secondarytext--text subtitle-1 font-weight-light"
      >
        <span class="font-weight-bold" v-if="item.label"
          >{{ item.label }}
        </span>
        <template v-if="item.value">
          {{ item.value }}
        </template>
        <template v-else>
          {{ item }}
        </template>
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "BulletedList",
  props: {
    color: { type: String },
    icon: { type: String },
    bullets: { type: Array }
  }
};
</script>

<style lang="scss" scoped>
.v-list-item {
  min-height: inherit;
}
</style>
